<div class="list-container">
  <h1 class="text-2xl font-bold mb-4">{{ 'SHOP-SELLER.LIST.TITLE' | translate }}</h1>

  @if (error) {
  <app-alert [type]="'danger'">{{ error }}</app-alert>
  }

  <!-- Filters Form -->
  <form
    (ngSubmit)="onSearch()"
    class="p-3 rounded-md mb-4 pt-4 dark:bg-neutral-900 dark:text-white"
    [class.flex]="version === 'v2'"
  >
    <div class="grid grid-cols-1 md:grid-cols-5 gap-4 w-full">
      @if (version === 'v1') {
        <div>
          <label class="block text-sm mb-1">{{ 'SHOP-SELLER.LIST.DOCUMENT_ID' | translate }}</label>
          <input
            [(ngModel)]="uiFilters.documentId"
            name="documentId"
            type="text"
            class="w-full px-3 py-2 dark:bg-neutral-800 dark:text-white border rounded-md bg-white text-black"
            placeholder="00000000-0000-0000-0000-000000000000"
          />
        </div>
      }
      <div>
        <label class="block text-sm mb-1">{{ 'SHOP-SELLER.LIST.LOGIN' | translate }}</label>
        <input
          [(ngModel)]="uiFilters.login"
          name="login"
          type="text"
          class="w-full px-3 py-2 dark:bg-neutral-800 dark:text-white border rounded-md bg-white text-black"
        />
      </div>
      <div>
        <label class="block text-sm mb-1">{{ 'SHOP-SELLER.LIST.EMAIL' | translate }}</label>
        <input
          [(ngModel)]="uiFilters.email"
          name="email"
          type="text"
          class="w-full px-3 py-2 dark:bg-neutral-800 dark:text-white border rounded-md bg-white text-black"
        />
      </div>
      <div>
        <label class="block text-sm mb-1">{{ 'SHOP-SELLER.LIST.NAME' | translate }}</label>
        <input
          [(ngModel)]="uiFilters.name"
          name="name"
          type="text"
          class="w-full px-3 py-2 dark:bg-neutral-800 dark:text-white border rounded-md bg-white text-black"
        />
      </div>
      <div>
        <label class="block text-sm mb-1">{{ 'SHOP-SELLER.LIST.AUTHORIZED' | translate }}</label>
        <select
          [(ngModel)]="uiFilters.authorized"
          name="authorized"
          class="w-full px-3 py-2 dark:bg-neutral-800 dark:text-white border rounded-md bg-white text-black"
        >
          <option value="">Todos</option>
          <option value="true">Sim</option>
          <option value="false">Não</option>
        </select>
      </div>
    </div>
    <div class="mt-4 flex gap-2">
      <app-button type="submit">Buscar</app-button>
      <app-button type="button" (click)="onClear()">Limpar</app-button>
    </div>
  </form>

  <div class="overflow-x-auto mt-2">
    <table class="table-auto w-full border-collapse border border-slate-400">
      <thead>
        <tr class="bg-neutral-100 dark:bg-neutral-700">
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">
            {{ 'SHOP-SELLER.LIST.ID' | translate }}
          </th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">
            {{ 'SHOP-SELLER.LIST.DOCUMENT_ID' | translate }}
          </th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">
            {{ 'SHOP-SELLER.LIST.LOGIN' | translate }}
          </th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">
            {{ 'SHOP-SELLER.LIST.EMAIL' | translate }}
          </th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">
            {{ 'SHOP-SELLER.LIST.NAME' | translate }}
          </th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">
            {{ 'SHOP-SELLER.LIST.AUTHORIZED' | translate }}
          </th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2"></th>
        </tr>
      </thead>
      <tbody>
        @for (batch of shopSellers; track getRouteId(batch); let even = $even) {
        <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
          <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ isMasterData(batch) ? '-' : batch.id }}</td>
          <td class="border border-neutral-300 dark:border-neutral-600 p-2">
            {{ batch.documentId }}
          </td>
          <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ batch.login }}</td>
          <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ batch.email }}</td>
          <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ batch.name }}</td>
          <td class="border border-neutral-300 dark:border-neutral-600 p-2">
            {{ batch.authorized ? 'Sim' : 'Não' }}
          </td>
          <td class="border border-neutral-300 dark:border-neutral-600 p-2">
            <a
              class="flex items-center justify-center underline"
              [routerLink]="[redirectBase, getRouteId(batch)]"
            >
              <i
                class="btn rounded-md flex items-center justify-center gap-2 bg-white border-black hover:bg-black hover:text-white dark:bg-black dark:border-white dark:hover:bg-white dark:hover:text-black py-1 px-3 text-sm"
                [innerHTML]="'eye' | feather : { width: 16, height: 16 }"
              ></i>
            </a>
          </td>
        </tr>
        } @empty {
        <tr class="bg-neutral-50 dark:bg-neutral-800">
          <td colspan="8">
            @if (paginationState().loading) {
            <app-loading size="large" color="primary" />
            } @else {
            {{ 'PAGINATION.NO_ITEMS' | translate }}
            }
          </td>
        </tr>
        }
      </tbody>
    </table>

    <app-pagination
      [paginationState]="paginationState()"
      [onPaginationChange]="onPageChange"
    ></app-pagination>
  </div>
</div>
